export default __webpack_public_path__ + "static/media/FontAwesome.91f80bba.otf";